<template>
  <div class="content-wrapper remove_table_shadow">
    <!-- <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('packages')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
     -->
    <!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("create_package") }}
          </button>
        </div> -->
    <!-- </div> -->
    <!-- </div> -->

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <div
      class="card card-with-search border-0 card-with-shadow d-none"
      v-for="(item, index) in packages"
      :key="index"
    >
      <div
        class="
          card-header
          d-flex
          justify-content-between
          align-items-center
          p-primary
          bg-transparent
        "
      >
        <h5 class="card-title d-inline-block mb-0">{{ item.title }}</h5>
      </div>
      <div class="card-body">
        <div class="text-justify" v-for="inc in item.include" :key="inc">
          {{ inc }}
        </div>
      </div>

      <app-button
        :label="$t('purchase_now')"
        class-name="btn-success mr-2"
        :is-disabled="false"
        @submit="btnSubmit(item.id)"
      />
    </div>

    <packages-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />
    <certificate-detail-view-modal
      v-if="isViewModalActive"
      :detail="certificateDetail"
      @close-modal="closeViewModal"
    />

    <!-- <app-delete-modal
            v-if="deleteConfirmationModalActive"
            :preloader="deleteLoader"
            modal-id="demo-delete"
            @confirmed="confirmed"
            @cancelled="cancelled"
        /> -->
  </div>
</template>

<script>
import * as actions from "@/app/Config/ApiUrl";
import CoreLibrary from "@/core/helpers/CoreLibrary";
import { TableHelpers } from "@Views/Demo/Tables/mixins/TableHelpers";
import { axiosGet, axiosPost } from "@/app/Helpers/AxiosHelper";
import AppFunction from "@/core/helpers/app/AppFunction";


export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      isViewModalActive: false,
      certificateDetail: {},
      packages: {},
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      input: {},
      options: {
        name: "AdvanceTable",
        url: actions.ADMIN_CERTIFICATE,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          // {
          //   title: this.$t("title"),
          //   type: "custom-html",
          //   key: "title",
          //   modifier: (value,row) => {
          //     return `<a href="#" id="${row.id}" @click=${this.myFunction(row)}>${this.$t(value)}</a>`;

          //     // return `<span>${this.$t(value)}</span>`;
          //   },
          // },
          {
              title: this.$t('title'),
              type: 'media-object',
              key: 'media-object',
              mediaTitleKey: 'title',
              // mediaSubtitleKey: 'amount',
              default: AppFunction.getAppUrl('images/bannerlayout.png'),
              modifier: (value, row) => {
                  return AppFunction.getAppUrl(row.logo ?? 'images/bannerlayout.png'); // imag url
              },
              isVisible: true
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "description",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "certificate_status",
            isVisible: true,
            modifier: (value) => {
              if (value != null) {
                let ClassName = "warning";

                if (value.status === "accepted") ClassName = `success`;
                else if (value.status === "rejected") ClassName = `danger`;

                return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                  value.status
                )}</span>`;
              }
            },
          },
        ],
        actions: [
          // {
          //   title: this.$t("edit"),
          //   icon: "edit",
          //   type: "none",
          //   component: "app-add-modal",
          //   modalId: "demo-add-edit-Modal",
          // },
          // {
          //   title: this.$t("delete"),
          //   icon: "trash",
          //   type: "none",
          //   component: "app-confirmation-modal",
          //   modalId: "demo-delete",
          // },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
          },
          {
            title: this.$t("apply"),
            icon: "bookmark",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
        ],
        filters: [
          // {
          //     "title": this.$t('date'),
          //     "type": "range-picker",
          //     "key": "date",
          //     "option": ["today", "thisMonth", "last7Days", "nextYear"]
          // },
          // {
          //     "title": this.$t('age'),
          //     "type": "range-filter",
          //     "key": "age-range",
          //     "maxTitle": this.$t('max_age'),
          //     "minTitle": this.$t('min_age'),
          //     "sign": ""
          // },
          // {
          //     "title": this.$t('status'),
          //     "type": "checkbox",
          //     "key": "status",
          //     "option": [
          //         {id: 'active', value: 'Active'},
          //         {id: 'inactive', value: 'Inactive'},
          //         {id: 'invited', value: 'Invited'},
          //     ],
          // },
          // {
          //     "title": this.$t('gender'),
          //     "type": "radio",
          //     "key": "filter-with-gender",
          //     "option": [
          //         {id: 'male', value: 'Male'},
          //         {id: 'female', value: 'Female'},
          //         {id: 'other', value: 'Other'},
          //     ],
          //     "header": {
          //         "title": this.$t('want_to_filter_your_list'),
          //         "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
          //     },
          // },
          // {
          //     "title": this.$t('search_and_select'),
          //     "type": "drop-down-filter",
          //     "key": "search select",
          //     "option": [],
          // }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions()
  },
  mounted() {
    // this.getPackages();
    setTimeout(() => {
      $(
        ".remove_table_shadow .h-100 .datatable .table-responsive "
      ).removeClass("shadow");
    }, 1000);
  },
  methods: {
    /**
     * for open add edit modal
     */
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.searchAndSelectFilterOptions()
      this.reSetData();
    },
    closeViewModal() {
      $("#view-detail-Modal").modal("hide");
      this.isViewModalActive = false;
      this.certificateDetail = {};
    },


    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t("view")) {
        this.view(this.rowData);
        
      } else if (actionObj.title == this.$t("select")) {
        this.buyerCertificate(rowData.id);
      } else if (actionObj.title == this.$t("apply")) {
        this.applyForCertificate(this.rowData);
      }
    },
    view(rowData) {
      this.certificateDetail = rowData;
      this.isViewModalActive = true;
    },
    myFunction(row){
      let doc = document.getElementById(row.id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(row);
        }) 
      }
    },

    buyerCertificate(id) {
      this.input.id = id;
      axiosPost(actions.BUYER_CERTIFICATE_STORE, this.input)
        .then((res) => {
          if (res.data.type == "success") {
            this.$toastr.s(res.data.message);
            location.reload();
          } else if (res.data.type == "applied") {
            this.$toastr.w(res.data.message);
          } else {
            this.$toastr.e(res.data.message);
          }
        })
        .catch((error) => {
          this.$toastr.e(error);
        });
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.PACKAGE_DISTROY}/${this.rowData.id}`;
      this.deleteLoader = true;
      axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          // this.searchAndSelectFilterOptions()
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      axiosGet(actions.DATATABLE_SEARCH_SELECT).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.name,
            value: name.name,
          };
        });
      });
    },
    applyForCertificate(certificate) {
      let certificate_id = certificate.id;
      axiosPost(actions.BUYER_CERTIFICATE_APPLY, {
        certificate_id: certificate_id,
      })
        .then((res) => {
          let message = res.data.message;
          this.$toastr.s(message);
        })
        .catch((error) => {
          
        });
    },
    // getPackages() {
    //   axiosGet(actions.ADMIN_CERTIFICATE)
    //     .then((res) => {
    //       this.packages = res.data.data;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },
    btnSubmit(id) {
      location.replace("/admin/stripePay/" + id);
    },
  },
};
</script>

<style scoped>
.remove_table_shadow .h-100 .datatable .table-responsive {
  box-shadow: none !important;
}
</style>
